<script>
export default {
    props: ["initRevenueArea"],

    data() {
        return {
            currentRevenueArea: this.initRevenueArea,
        };
    }
};
</script>
